import { useState, useContext } from "react";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Collapse, Divider, IconButton, Typography } from "@mui/material";

import classes from "./Share.module.css";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import { DiscoveryContext } from "../discovery-context";
import { toast } from "react-toastify";
import { AuthContext } from "../../../context/auth-context";
import ShareUserPicker from "../../../Component/ShareModal/ShareUserPicker";

const SHARE_REPORT_ENDPOINT = "/userset/share/transaction";

export default function Share() {
  const discoveryCtx = useContext(DiscoveryContext);
  const [isCopied, setIsCopied] = useState(false);
  const [usersExpanded, setUsersExpanded] = useState(true);
  const { user, selectedCustomerId } = useContext(AuthContext);
  const docId = discoveryCtx.state.transactionId;
  const type = discoveryCtx.type;
  const documentPath = `${window.location.origin}${window.location.pathname}?type=${type}&id=${docId}&user_id=${user?.user_role?.user_id}&customer_id=${selectedCustomerId}`;
  const itemName = `${discoveryCtx.entity} Discovery`;

  async function handleCopy() {
    await navigator.clipboard.writeText(documentPath);
    setIsCopied(true);
    toast.success("Share link is copied.");
    setTimeout(() => {
      setIsCopied(false);
    }, 4000);
  }

  const buildSharePayload = (item, targets) => ({
    transaction_id: docId,
    user_id: user?.user_role?.user_id,
    customer_id: user?.customer_id,
    targets,
  });

  const parseShareResponse = (data) => [
    ...(data?.shared ?? []).map((s) => ({ ...s, status: "created", final_name: itemName })),
    ...(data?.already_shared ?? []).map((s) => ({ ...s, status: "skipped_self" })),
  ];

  return (
    <div>
      <div className={classes.label}>{itemName}</div>
      <div className={classes.copy_container}>
        <span className={classes.path}>{documentPath}</span>
        <MUIIconButton onClick={handleCopy} tooltip="Click to copy">
          {isCopied ? (
            <DoneOutlinedIcon color="success" />
          ) : (
            <ContentCopyOutlinedIcon />
          )}
        </MUIIconButton>
      </div>

      {user?.is_sharing_enabled && (
        <Box sx={{ mt: 2 }}>
          <Divider sx={{ mb: 1.5 }} />
          <Box
            onClick={() => setUsersExpanded((prev) => !prev)}
            sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }}
          >
            <Typography variant="subtitle2">Share with other users</Typography>
            <IconButton size="small">
              {usersExpanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
            </IconButton>
          </Box>
          <Collapse in={usersExpanded}>
            <Box sx={{ mt: 1 }}>
              <ShareUserPicker
                item={{ id: docId, name: itemName }}
                itemTypeLabel="discovery report"
                shareEndpoint={SHARE_REPORT_ENDPOINT}
                buildPayload={buildSharePayload}
                onClose={() => setUsersExpanded(false)}
                description="Selected users get access to this report in their account. They cannot edit or delete your original."
                excludeUserId={user?.user_role?.user_id}
                parseShareResponse={parseShareResponse}
                alreadyHasAccessMessage="already has access to this report, no action taken"
              />
            </Box>
          </Collapse>
        </Box>
      )}
    </div>
  );
}
